class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');
  }

  connectedCallback() {
    this.select.addEventListener('change', this._onChange.bind(this));
  }

  disconnectedCallback() {
    this.select.removeEventListener('change', this._onChange.bind(this));
  }

  _onChange() {
    this.form.requestSubmit();
  }
}

customElements.define('localization-form', LocalizationForm);
